import { ReportSearchModel } from '@/types';
import ReportListCardGD from './ReportListCardGD';
import ReportListCardStylus from './ReportListCardStylus';

export interface ReportListCardModel {
  data: ReportSearchModel;
  className?: string;
  small?: boolean;
  hideViewed?: boolean;
  showActionButtons?: boolean;
  onClick?: (e: React.MouseEvent, data: ReportSearchModel) => void;
}

const ReportListCard = ({ data, ...props }: ReportListCardModel) => {
  if (data.isGdReport) {
    return <ReportListCardGD data={data} {...props} />;
  } else {
    return <ReportListCardStylus data={data} {...props} />;
  }
};

export default ReportListCard;
